import reduxStore from 'lib/reduxStore'
import { resetAll } from 'redux/features/auth/authSlice'
import routesConfig from 'lib/routesConfig'

export function reauthenticate() {
  reduxStore.dispatch(resetAll())
  routesConfig.BCC_LOGIN.goto(undefined, true)
}
